import React from 'react';
import { TrendingUp } from 'lucide-react';

const SPEED_MAP = {
  slow: '60s',
  normal: '40s',
  fast: '25s',
};

const OpportunityTicker = ({ deals = [], speed = 'normal' }) => {
  if (!deals || deals.length === 0) return null;

  const duration = SPEED_MAP[speed] || SPEED_MAP.normal;

  // Duplicate items for seamless loop
  const items = [...deals, ...deals];

  return (
    <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-slate-800 to-slate-900 text-white">
      <div className="flex items-center">
        {/* Static label */}
        <div className="flex-shrink-0 flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2.5 sm:py-3 bg-slate-700/50 border-r border-slate-600 z-10">
          <TrendingUp className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-emerald-400" />
          <span className="text-[10px] sm:text-xs font-semibold uppercase tracking-wider text-emerald-400">Live</span>
        </div>

        {/* Scrolling ticker */}
        <div className="overflow-hidden flex-1">
          <div
            className="flex items-center gap-8 whitespace-nowrap ticker-scroll"
            style={{ animationDuration: duration }}
          >
            {items.map((deal, idx) => (
              <span key={`${deal.id}-${idx}`} className="inline-flex items-center gap-3 py-3 text-sm">
                <span className="text-slate-400">|</span>
                <span className="font-medium">{deal.title || 'Untitled'}</span>
                {deal.commodity && (
                  <span className="bg-slate-700 text-emerald-300 text-xs px-2 py-0.5 rounded-full">
                    {deal.commodity}
                  </span>
                )}
                {deal.quantity && (
                  <span className="text-slate-400 text-xs">{deal.quantity}</span>
                )}
                {deal.country && (
                  <span className="text-slate-500 text-xs">{deal.country}</span>
                )}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* CSS animation */}
      <style>{`
        @keyframes ticker-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .ticker-scroll {
          animation: ticker-scroll linear infinite;
        }
        .ticker-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default OpportunityTicker;
